import { Chip } from "@mui/material";
import { useMemo } from "react";

export interface IAuditStateChip {
    state? : string;
}

function AuditStateChip(props : IAuditStateChip) {
    const isInfo = useMemo(() => {
       return (props?.state?.toLowerCase() === 'info');
    }, [props.state]);

    const isError = useMemo(() => {
       return (props?.state?.toLowerCase() === 'failure');
    }, [props.state]);

    const isSuccess = useMemo(() => {
       return (props?.state?.toLowerCase() === 'success');
    }, [props.state]);

    return (
        <div>
            { isError && <Chip size='small' key='incomplete' label='Failure' color="error" /> }
            { isInfo && <Chip size='small' label={'Info'} color="info" /> }
            { isSuccess && <Chip size='small' label={'Succeeded'} color="success" /> }
        </div>
        
    )
}

export default AuditStateChip;